import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
`;

export const ImageWrapper = styled.div`
	width: 100%;
	max-height: 206px;
	margin-bottom: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;

export const Image = styled.img`
	max-height: 206px;
`;

export const ChipRow = styled.div`
	margin: 6px 0;
`;

export const Chip = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	width: fit-content;
	padding: 6px 8px;
	border-radius: 100px;
	font-size: 14px;
	line-height: 19px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	background-color: ${({ theme }) => theme.colors.transparent.light10};

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};

		rect {
			fill: ${({ theme }) => theme.colors.icon.main};
		}
	}
`;

export const Description = styled.p`
	margin: 6px 0 4px;
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const FooterRow = styled.div`
	padding: 12px 0;
	display: flex;
	align-items: center;
`;

export const FooterRight = styled.div`
	margin-left: auto;
	display: flex;
	gap: 16px;
`;
